import React from 'react';
import './orderTableLabel.scss';

const OrderTableLabel = ({ txt }) => {
  return (
    <div className="order-table-label">
      <div className="txt-l">
        {txt?.length > 12 ? `...${txt.slice(-12)}` : txt}
      </div>
    </div>
  );
};

export default OrderTableLabel;
